// ── markPlan ──────────────────────────────────────────────────────────────────
// The ONE decision behind "mark episode N of season S watched" on the v17 show
// page: what progress pointer to save, which episode is the endpoint, whether a
// range (cascade) is covered, and whether the show is now finished. Pure, so it
// is testable without React. Mirrors the rules ShowDetail.jsx's onMarkWatched
// grew over 16.x (season-boundary advance via the next EXISTING season, no ghost
// episodes, seriesFinale only for a confirmed-ended show).
import { getValidSeasons, isEndedStatus } from './episode.js'

// next = the user's current next-to-watch {season, episode} (or null).
export function planMark(show, next, season, ep) {
  const seasons = getValidSeasons(show?.seasons)
  const seasonData = seasons.find(s => s.season_number === season)
  const lastEp = seasonData?.episode_count || 99
  const cascadeFrom = next && next.season === season && next.episode < ep ? next.episode : null
  const watchedRange = cascadeFrom != null ? { season, from: cascadeFrom } : undefined
  const watchedEp = { season, episode: ep }
  if (ep >= lastEp) {
    const nxt = seasons.filter(s => s.season_number > season).sort((a, b) => a.season_number - b.season_number)[0]
    if (nxt) return { prog: { season: nxt.season_number, episode: 1 }, opts: { watchedEp, watchedRange }, selectSeason: nxt.season_number, cascade: cascadeFrom != null }
    const ended = isEndedStatus(show?.status)
    return { prog: { season, episode: ep + 1 }, opts: { watchedEp, watchedRange, ...(ended ? { seriesFinale: true } : {}) }, selectSeason: season, cascade: cascadeFrom != null, finale: ended }
  }
  return { prog: { season, episode: ep + 1 }, opts: { watchedEp, watchedRange }, selectSeason: season, cascade: cascadeFrom != null }
}

// Rewinding: tapping a watched ring makes it the next-to-watch again.
export function planRewind(season, ep) {
  return { prog: { season, episode: ep }, opts: { watchedEp: null } }
}
